const handleTabs = (tabsContainer = '.js-tabs') => {
	const $tabsContainer = $(tabsContainer);

	$tabsContainer.find('.product__tabs-nav').on('click', 'a', function(event) {
		const $this = $(this);
		const $target = $($this.attr('href'));

		$this.closest('li')
			.addClass('is-current')
			.siblings()
			.removeClass('is-current');

		$target.addClass('is-current')
			.siblings()
			.removeClass('is-current');

		event.preventDefault();
	});
}

handleTabs();
